import React, { useState, useEffect, forwardRef } from 'react';
import './S1Input.style.scss'; // Ensure the path is correct

const S1Input = forwardRef(({ placeholder, background, percent, disabled, value, onKeyUpChange, onFocus }, ref) => {
  const [inputValue, setInputValue] = useState(value || ""); // Initialize with the passed value
  const [hasValue, setHasValue] = useState(false);

  useEffect(() => {
    setInputValue(value || ""); // Update the internal state if the `value` prop changes
    setHasValue(value?.trim() !== ""); // Update the `hasValue` state
  }, [value]);

  const handleKeyUp = (event) => {
    if (onKeyUpChange) {
      onKeyUpChange(event.target.value); // Send the input value back to the parent component
    }
  };

  const handleChange = (event) => {
    const input = event.target.value;
    setInputValue(input); // Update internal state for controlled input
    setHasValue(input.trim() !== ""); // Update `hasValue` state based on input
  };

  const handleClear = () => {
    setInputValue(""); // Clear the input value
    setHasValue(false); // Reset `hasValue` state
    if (onKeyUpChange) {
      onKeyUpChange(""); // Notify parent of cleared input
    }
  };

  return (
    <div className="fbx-s1-input-container" style={{ position: 'relative', width: percent}}>
      <input
        ref={ref} // Attach the forwarded ref to the input element
        className="fbx-s1-form-control"
        type="text"
        placeholder={placeholder}
        style={{
          backgroundColor: hasValue ? 'black' : background,
          color: hasValue ? 'yellow' : 'inherit',
          width: '100%', // Full width within the container
          fontSize: 'small',
          paddingRight: '30px', // Space for the clear button
          marginRight: "0px",
          borderRight: "none",
          borderRadius: "4px 0px 0px 4px"
        }}
        value={inputValue} // Bind the internal state to the input element
        onChange={handleChange} // Attach the change event handler
        onKeyUp={handleKeyUp} // Attach the keyup event handler
        onFocus={onFocus} // Attach focus event handler if provided
        disabled={disabled || false}
      />
      {hasValue && (
        <button
          className="fbx-s1-clear-button"
          onClick={handleClear}
          tabIndex="-1"
          style={{
            marginLeft: "0px",
            width: "33px",
            height: "33px",
            lineHeight: "33px",
            backgroundColor: value !== "-" && value !== "" ? "black" : background,
            color: value !== "-" && value !== "" ? "yellow" : "lightGrey",
            border: "1px solid #ced4da",
            borderLeft: "none",
            borderRadius: "0px 4px 4px 0px",
            cursor: value !== "-" && value !== "" ? "pointer" : "default",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
          }}
          aria-label="Clear input"
        >
          X
        </button>
      )}
    </div>
  );
});

export default S1Input;
